/*
 * massage-session (schema)
 */
import { boolean, date, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { patients } from "../patient/patient.schema"
import { practitioners } from "../practitioner/practitioner.schema"
import { generalNotes } from "../general-note/general-note.schema"

export const massageSessions = schema.table("massage_sessions", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),
	therapistId: uuid("therapist_id").references(() => practitioners.id, { onDelete: "set null" }),
	generalNoteId: uuid("general_note_id").references(() => generalNotes.id, { onDelete: "set null" }),

	// --- Session ---
	sessionDate: date("session_date").notNull(),
	startTime: timestamp("start_time", { withTimezone: true }),
	endTime: timestamp("end_time", { withTimezone: true }),
	notes: text("notes"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
